module.exports = __webpack_public_path__ + "static/img/md.d692cd26.svg";